import { c as _c } from "react/compiler-runtime";
import { Text } from "@flat-ui";
import { withEllipsis } from "@styles/common-styles";
/** Single info item of the subscription details */
export function SubscriptionInfoItem(t0) {
  const $ = _c(4);
  const {
    text,
    shouldNotTranslate
  } = t0;
  const t1 = shouldNotTranslate ? "var" : "div";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      ...withEllipsis
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1 || $[2] !== text) {
    t3 = <Text component={t1} variant="bodyL" sx={t2}>{text}</Text>;
    $[1] = t1;
    $[2] = text;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}